<template>
  <div class="qrcode-page">
    <!-- 用户信息和二维码区域 -->
    <div class="content">
      <!-- 用户信息 -->
      <div class="user-info" ref="userInfo">
        <div style="display: flex; align-items: center;margin-top: 20px;">
          <div class="avatar">
            <van-icon name="contact" />
          </div>
          <div class="info">
            <div class="name">{{ userInfo.username }}</div>
            <div class="name">{{ userInfo.phone }}</div>
          </div>
        </div>
        <!-- 二维码区域 -->
        <div class="qrcode-container">
          <canvas ref="qrcodeCanvas" class="qrcode-canvas"></canvas>
        </div>
        <!-- 提示文字 -->
        <div class="tip-text">
          扫一扫上面的二维码图案，注册服务号。
        </div>
      </div>
      <!-- 底部按钮 -->
      <div class="footer">
        <div class="action-btn" @click="saveImage">长按保存图片</div>
      </div>
    </div>

    <!-- 生成的图片预览，长按保存 -->
    <div v-if="previewImageUrl" class="image-preview" @click="closePreview">
      <img :src="previewImageUrl" alt="长按保存图片" />
      <div class="preview-tip">长按图片保存到相册</div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcode";
import { getUserInfo } from '@/api/index'
import html2canvas from 'html2canvas';

export default {
  name: 'QRCodePage',
  data() {
    return {
      userInfo: {},
      qrcodeLink: 'https://zhfwpt.weixin.54zkjl.com/#/code?state=signup&code=', // 二维码链接，实际使用时替换
      qrcodeOptions: {
        width: 240,
        margin: 1,
        color: {
          dark: '#aa376e',
          light: '#ffffff'
        }
      },
      currentStyleIndex: 0,
      styleOptions: [
        { colorStops: [{ offset: 0, color: '#e74c3c' }, { offset: 1, color: '#8e44ad' }] },
        { colorStops: [{ offset: 0, color: '#3498db' }, { offset: 1, color: '#2ecc71' }] },
        { colorStops: [{ offset: 0, color: '#e67e22' }, { offset: 1, color: '#f1c40f' }] }
      ],
      previewImageUrl: '' // 预览图片地址
    }
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      getUserInfo().then((res) => {
        this.userInfo = res;
        this.qrcodeLink = 'https://zhfwpt.weixin.54zkjl.com/#/code?website=signup&code=' + res.inviterCode
        localStorage.setItem('user', JSON.stringify(res));
        this.generateQRCode()
      })
    },
    generateQRCode() {
      const canvas = this.$refs.qrcodeCanvas
      const options = { ...this.qrcodeOptions }
      const currentStyle = this.styleOptions[this.currentStyleIndex]
      options.colorStops = currentStyle.colorStops
      QRCode.toCanvas(canvas, this.qrcodeLink, options, (error) => {
        if (error) {
          console.error('二维码生成失败:', error)
        }
      })
    },
    saveImage() {
      const targetDom = this.$refs.userInfo;
      html2canvas(targetDom, { useCORS: true }).then(canvas => {
        const dataUrl = canvas.toDataURL('image/png');
        this.previewImageUrl = dataUrl; // 显示预览图片
      }).catch(err => {
        console.error('保存图片失败:', err);
      });
    },
    closePreview() {
      this.previewImageUrl = '';
    }
  }
}
</script>

<style scoped>
.qrcode-page {
  width: 100%;
  min-height: 100vh;
  background-color: #f8f8f8;
  display: flex;
  flex-direction: column;
  position: relative;
}

/* 内容区域样式 */
.user-info {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  flex-direction: column;
  margin-top: 25%;
}

.avatar {
  width: 60px;
  height: 60px;
  border-radius: 4px;
  overflow: hidden;
  font-size: 50px;
  margin-right: 15px;
}

.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.info {
  display: flex;
  flex-direction: column;
}

.name {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 5px;
}

/* 二维码样式 */
.qrcode-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.qrcode-canvas {
  width: 240px;
  height: 240px;
}

/* 提示文字 */
.tip-text {
  margin: 20px 0;
  font-size: 14px;
  color: #666;
  text-align: center;
}

/* 底部按钮 */
.footer {
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  color: #365ba4;
}

.action-btn {
  padding: 0 15px;
  font-size: 15px;
  color: #365ba4;
  cursor: pointer;
}

/* 预览图层样式 */
.image-preview {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.image-preview img {
  max-width: 80%;
  max-height: 60%;
  border-radius: 8px;
}

.preview-tip {
  color: #fff;
  font-size: 16px;
  margin-top: 15px;
}
</style>
